import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Modules } from 'src/app/core/model/modules.enum';
import { AuthService } from 'src/app/providers/auth.service';

@Component({
  selector: 'app-dashboardv2',
  templateUrl: './dashboardv2.component.html',
  styleUrls: ['./dashboardv2.component.scss']
})
export class Dashboardv2Component implements OnInit {

  public userPrivilege: any;
    public userType: string = "";

    constructor(private auth: AuthService, private messageService: MessageService,) {
    }

    async ngOnInit(): Promise<any> {
        this.userType = this.getUserType();
    }

    sleeper = (delay) => new Promise((resolve) => setTimeout(resolve, delay));

    isPermission(privilege) {
        return this.userPrivilege.indexOf(privilege) != -1;
    }

    getUserType() {
        return this.auth.getUser.userType;
    }

    getPrivileges() {
        return this.auth.getPrivileges(Modules.USER).features;
    }

    showAlert(data, alertType) {
        this.messageService.add({
            severity: alertType,
            summary: data.status,
            detail: data.message,
        });
    }
}
